import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import authActions from './features/auth/actions'
import { selectAuthToken, selectUsername } from './features/auth/selectors'
import { TDispatch } from './model/model'
import LoginPage from './pages/LoginPage'
import SelectRoomPage from './pages/SelectRoomPage'
import Routes from './Routes'
import { selectRoomId, selectStoreId } from './features/settings/selectors'
import { SignalRContext } from './providers/SignalRProvider'
import { notificationsService } from './utils/signalRNotifications/notifications-service'
import {
	NotificationEventType,
	NotificationMessage,
} from './model/signalRNotifications'
import { useEvent } from './hooks/useEvent'

const onUnload = () => {
	return
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const App = () => {
	const { connectionId } = useContext(SignalRContext)
	const { subscribe } = useEvent()
	const token = useSelector(selectAuthToken)
	const dispatch: TDispatch = useDispatch()
	const username = useSelector(selectUsername)
	const storeId = useSelector(selectStoreId)
	const roomId = useSelector(selectRoomId)

	useEffect(() => {
		if (!username) {
			return
		}

		dispatch(authActions.fetchUser())
	}, [dispatch, username])

	useEffect(() => {
		subscribe(
			NotificationEventType.DataUpdated,
			(event: NotificationMessage) => {
				console.log('SignalR received event', event)
			},
		)
	}, [])

	useEffect(() => {
		if (!connectionId) {
			return
		}

		const groupName = 'exam:12345'
		notificationsService.addConnectionToGroup(groupName)

		return () => {
			notificationsService.removeConnectionFromGroup(groupName)
		}
	}, [connectionId])

	useEffect(() => {
		window.addEventListener('unload', onUnload)
		return () => window.removeEventListener('unload', onUnload)
	}, [])

	if (!token) {
		return <LoginPage />
	} else if (!storeId || !roomId) {
		return <SelectRoomPage />
	} else {
		return <Routes />
	}
}

export default App
